import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../modal-service/modal.service';
import { ProductCustomerSizeModel } from './models/product-customer-size-model';
import { ProductCustomerSizeComponent } from '../products/product-customer-size/product-customer-size.component';
import { ProductIdsModel } from 'app/core/models/product-ids.model';
import { MakeYearModel, SimpleMakeYearModel } from 'app/core/models/make-year-model.model';
import { Helper } from '../helper';
import { Observable } from 'rxjs';
import { CustomerSizeOffsetValidityDtoResponse } from 'app/core/models/customer-size-offset-validity.dto-response';
import { WheelService } from '../wheel.service';
import { ProductCardDtoResponse } from 'app/core/models/product-card-dto-response';
import { Constants } from 'app/core/Constants';

@Injectable()
export class ProductCustomerSizeService {
  
  constructor(private modalService: ModalService,
    private translateService: TranslateService,
    private wheelService: WheelService) { }

  showProductCustomerSize(mym: MakeYearModel, frontProduct: ProductCardDtoResponse,
    rearProduct: ProductCardDtoResponse, isAggressive: boolean,
    targetClass?: string): Promise<ProductCustomerSizeModel> {
    let productIds: ProductIdsModel = new ProductIdsModel();
    productIds.front = Constants.CUSTOMER_SIZE
      + frontProduct.details.details.find(d => d.label === Constants.SIZE_DETAIL_LABEL).value.replace(" ", "").replace(" ", "").replace("\"", "");
    if (rearProduct !== null)
      productIds.rear = Constants.CUSTOMER_SIZE
        + rearProduct.details.details.find(d => d.label === Constants.SIZE_DETAIL_LABEL).value.replace(" ", "").replace(" ", "").replace("\"", "");
    else
      productIds.rear = '';
    return this.openCustomerSizeModal(<ProductCustomerSizeModel>{
      mym: mym,
      productIds: productIds,
      isStaggered: rearProduct ===null? false:true,
      isAggressive: isAggressive,
      frontOffset: null,
      rearOffset:null
    }, targetClass);
  }

  private openCustomerSizeModal(productCustomerSizeModel: ProductCustomerSizeModel, targetClass?: string): Promise<ProductCustomerSizeModel> {
    let customWindowClass = 'fastco-modal';
    if (targetClass !== undefined) {
      customWindowClass += ' ' + targetClass;
    }

    const modalRef = this.modalService.open(ProductCustomerSizeComponent,
      {
        windowClass: customWindowClass,
        backdrop: 'static'
      });

    (<ProductCustomerSizeComponent>modalRef.componentInstance).init(productCustomerSizeModel, this);
    return modalRef.result;
  }

  async CustomerSizeOffsetValidity(searchParams: SimpleMakeYearModel,
    productIds: ProductIdsModel, frontOffset: string, rearOffset: string,
    isAggressive: boolean, controlName: string) {
    let invalid = false;
    const validOffsets = await this.wheelService.getCustomerSizeOffsetValidity(searchParams,
      productIds, frontOffset, rearOffset, isAggressive).first().toPromise();
    if (validOffsets !== null) {
      if ((controlName === "frontOffset" && productIds.rear === '' && (validOffsets.validOffset1 === false || validOffsets.validOffset2 === false))
        || (controlName === "frontOffset" && productIds.rear !== '' && validOffsets.validOffset1 === false)
        || (controlName === "rearOffset" && productIds.rear !== '' && validOffsets.validOffset2 === false)
        || (controlName === "" && (validOffsets.validOffset1 === false || (validOffsets.validOffset2 === false /*&& productIds.rear !== ''*/)))
      ) {
        invalid = true;
      }
    }
    return invalid;
  }
  async CustomerSizeOffsetValid(searchParams: SimpleMakeYearModel,
    productIds: ProductIdsModel, frontOffset: string, rearOffset: string,
    isAggressive: boolean) {
    const validOffsets = await this.wheelService.getCustomerSizeOffsetValidity(searchParams,
      productIds, frontOffset, rearOffset, isAggressive).first().toPromise();
    return validOffsets;
  }
}
